<template>
  <region-selector v-if="modernSelection" @manage="openFullManagement" />
  <div v-else class="region_manage_background">
    <!-- 上部导航栏样式 -->
    <div class="main_topnav config_main_manage_topnav">
      <top-nav class="main_topnav">
        <top-nav-item class="left_item" @click.native="regionManageReturnBtnHandle">
          <img class="main_top_img" slot="topnavimg" src="~assets/img/topnav/zuofanhui.png" alt />
          <div slot="topimgtext">返回</div>
        </top-nav-item>
        <top-nav-item>
          <div slot="topimgtext">区域管理</div>
        </top-nav-item>
        <top-nav-item class="right_item" @click.native="regionManageBtnHandle">
          <div slot="topimgtext">{{ regionManageState }}</div>
          <img class="main_top_img" slot="topnavimg" src="~assets/img/topnav/shezhi.png" alt />
        </top-nav-item>
      </top-nav>
    </div>

    <!-- 设置页面的内容区域 -->
    <div class="region_manage_page_wraper">
      <div class="region_manage_page_content">
        <!-- 设置页面收藏区域的灰色title样式 -->
        <div class="config_title_hang_wraper">
          <span>收藏的区域</span>
        </div>
        <!-- 设置页面收藏区域的内容区域样式 -->
        <div
          v-for="(value, index) in serveRegionListData.followRegion"
          :key="value.regionName"
          class="config_text_hang_wraper"
          @click="regionGoBtnHandle(value)"
        >
          <input
            class="config_left_text"
            type="text"
            name
            id
            v-model="value.regionName"
            :disabled="ifNameChange"
            :class="
              regionManageState === '区域管理'
                ? 'region_manage_input_zindex'
                : ''
            "
          />
          <img
            v-if="regionManageState === '区域管理'"
            src="~assets/img/config/youjiantou.png"
            alt
            class="config_text_img"
          />
          <!-- 收藏按钮 -->
          <img
            v-if="regionManageState === '退出' && value.followState === 1"
            src="~assets/img/config/quxiaoshouchang.png"
            alt
            class="region_config_shouchang_img"
            @click.stop="regionManageQuXiaoShouChangBtnHandle(index, value)"
          />
        </div>
        <!-- 收藏没有内容时的提示样式 -->
        <div
          v-if="serveRegionListData.followRegion.length === 0"
          class="config_notext_hang_tisp_wraper"
        >
          <span>还没有收藏的区域，快去点击区域管理设置自己常用的区域吧~</span>
        </div>

        <!-- 设置页面所有区域的灰色title样式 -->
        <div class="config_title_hang_wraper">
          <span>全部的区域</span>
          <div
            class="click_add_delete_btn"
            v-if="regionManageState === '退出'"
            @click="regionMansgeAddBtnHandle"
          >
            <img v-if="userType == 0 " src="~assets/img/config/add.png" alt />
            <span v-if="userType == 0 ">添加或删除</span>
          </div>
        </div>
        <!-- 设置页面所有区域的内容样式 -->
        <div
          v-for="(value, index) in serveRegionListData.allRegion"
          :key="index"
          class="config_text_hang_wraper"
          v-show="
            !(
              (regionManageState === '退出' &&
                value.regionName === '默认区域') ||
              (regionManageState === '退出' && value.regionName === '全部区域')
            )
          "
          @click="regionGoBtnHandle(value)"
        >
          <!-- <span class="config_left_text">{{value.regionName}}</span> -->
          <input
            class="config_left_text"
            type="text"
            name
            :id="index"
            v-model="value.regionName"
            :disabled="!ifNameChange[index]"
            placeholder="请输入新的区域名称"
            :class="
              regionManageState === '区域管理'
                ? 'region_manage_input_zindex'
                : ''
            "
          />
          <!-- 区域管理按钮 -->
          <img
            v-if="regionManageState === '区域管理'"
            src="~assets/img/config/youjiantou.png"
            alt
            class="config_text_img"
          />
          <!-- 修改按钮 -->
          <img
            v-if="
              regionManageState === '退出' &&
                !ifNameChange[index] &&
                !addDeleteFlang &&
                userType == 0 
            "
            src="~assets/img/config/xiugai.png"
            alt
            class="region_config_xiugai_img"
            @click.stop="regionManageXiuGaiBtnHandle(index, value)"
          />
          <!-- 对号确认按钮  不是新添加一行或删除一行的状态下-->
          <img
            v-if="
              regionManageState === '退出' &&
                ifNameChange[index] &&
                !addDeleteFlang
            "
            src="~assets/img/config/duihao.png"
            alt
            class="region_config_xiugai_img"
            @click.stop="regionManageQueRenBtnHandle(index, value)"
          />
          <!-- 对号确认按钮  新添加一行或删除一行的状态下  只有index0 需要显示-->
          <img
            v-if="
              regionManageState === '退出' &&
                ifNameChange[index] &&
                index === 0 &&
                addDeleteFlang === true
            "
            src="~assets/img/config/duihao.png"
            alt
            class="region_config_xiugai_img"
            @click.stop="regionManageQueRenBtnHandle(index, value)"
          />
          <!-- 收藏按钮 -->
          <img
            v-if="
              regionManageState === '退出' &&
                !addDeleteFlang &&
                value.followState === 0
            "
            src="~assets/img/config/shouchang.png"
            alt
            class="region_config_shouchang_img"
            @click.stop="regionManageShouChangBtnHandle(index, value)"
          />
          <!-- 删除按钮 -->
          <img
            v-if="regionManageState === '退出' && addDeleteFlang"
            src="~assets/img/config/jianshao.png"
            alt
            class="region_config_shouchang_img"
            @click.stop="regionManageDeleteBtnHandle(index, value)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RegionSelector from '@/components/content/contro-view/region-selector';
import {getServerApiLevelState} from '@/common/compatibility/server-api-level';
import topNav from "components/common/topnav/topnav";
import topNavItem from "components/common/topnav/topnavitem";
export default {
  data() {
    return {
      userType: sessionStorage.getItem("userType"), ////获取子账号和主账号的状态  0主账号1子账号
      serveRegionListData: {
        ///服务器返回的所有区域信息的数据
        allRegion: [], ///所有的区域信息
        followRegion: [] ////收藏的区域信息
      },
      userRegionListCache: {},
      ifNameChange: [],
      addDeleteFlang: false,
      modernSelection:getServerApiLevelState(this).useModernRegion && !['config','manage'].includes(this.$route.query.type),
      regionManageState: "区域管理"
    };
  },
  components: {
    RegionSelector,
    topNav,
    topNavItem
  },
  methods: {
    loadRegionManagement() {
    console.log("created阶段");
    /// 请求区域信息接口，获取数据
    this.$request({
      method: "post",
      url: "/region/findRegion",
      data: {
        token: this.$store.state.token
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message);
          ////说明信息填写错误,控制失败了，
          return;
        } else {
          ////、控制成功了
          this.serveRegionListData = res.data.data; ////拿到服务器返回的数据结果
          /////在最后添加一个全部区域
          let allregionInfo = {
            followState: 0,
            followTime: "",
            regionId: "",
            regionName: "全部区域",
            userId: ""
          };

          this.serveRegionListData.allRegion.push(allregionInfo);
          console.log(this.serveRegionListData);
          ////从配置页面的添加一个新区域的按钮点击，进来之后需要激活进入对应的状态
          console.log(this.$route.query.type);
          if (this.$route.query.type === "manage") this.regionManageState = "退出";
          if (this.$route.query.type === "config") {
            ////说明是从配置页面进来的，需要直接进入添加一个区域的状态
            this.regionManageState = "退出";
            this.regionMansgeAddBtnHandle();
          }
          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

    openFullManagement(){this.modernSelection=false;this.regionManageState="退出";this.loadRegionManagement()},
    regionManageBtnHandle() {
      ////区域管理或退出按钮点击了
      if (this.regionManageState === "区域管理") {
        this.regionManageState = "退出";
      } else {
        if (this.$route.query.type === "config") {
          //说明是从配置页面进来的
          this.$router.go(-1);
          return;
        }

        this.regionManageState = "区域管理";
        if (this.addDeleteFlang === true) {
          ////  说明退出之前是添加新的一行的状态
          this.serveRegionListData.allRegion.splice(0, 1); ////通过这种方式修改数组值才可以实时更新到VIEW上  VUE的规定
          this.addDeleteFlang = false; ///添加新的一行和删除标志位
          this.ifNameChange[0] = false; ///第一行的对号隐藏
        } else {
          ////所有对号隐藏
          for (let i = 0; i < this.serveRegionListData.allRegion.length; i++) {
            this.ifNameChange[i] = false;
          }
        }
      }
    },
    regionManageXiuGaiBtnHandle(index, value) {
      // 修改按钮点击了
      // 取消所有的修改按钮状态，保证只有一个区域处理修改状态
      for (let i = 0; i < this.serveRegionListData.allRegion.length; i++) {
        if (i === index) continue; ///结束本次循环，进入下一次循环
        this.ifNameChange[i] = false;
      }
      this.ifNameChange.splice(index, 1, true); ////通过这种方式修改数组值才可以实时更新到VIEW上  VUE的规定

      console.log(index);

      // /////需要延时一下等待 input的禁用状态被更新为激活状态后 才能使用聚焦事件
      this.$nextTick(() => {
        //VUE的激活后聚焦的正确写法
        document.getElementById(index).focus(); ////聚焦
      });
    },
    regionManageQueRenBtnHandle(index, value) {
      // 修改后或新增区域后确认按钮被点击了
      if (this.addDeleteFlang === true) {
        ///说明是添加一行时确认按钮需要的操作
        if (value.regionName.match(/^[ ]*$/)) {
          ////判断是否为多个空格的方法
          ///说明用户没有输入名称就点了确认按钮，所以需要删掉
          this.serveRegionListData.allRegion.splice(index, 1); ////通过这种方式修改数组值才可以实时更新到VIEW上  VUE的规定
          this.addDeleteFlang = false; ///添加新的一行和删除标志位
          this.ifNameChange[index] = false; ///第一行的对号隐藏
        } else if (value.regionName.length > 20) {
          this.$toast("添加失败，名称不能超过20个字符哦~");
          return;
        } else {
          ///用户输入了名称，需要请求添加一个区域的接口
          this.$request({
            method: "post",
            url: "/region/saveRegion",
            data: {
              token: this.$store.state.token,
              regionName: value.regionName
            }
          })
            .then(res => {
              if (res.data.code != 0) {
                this.$showTips1Toast(3, res.data.message);
                ////说明信息填写错误,控制失败了，
                return;
              } else {
                ////、控制成功了
                this.addDeleteFlang = false; ///添加新的一行和删除标志位
                this.ifNameChange.splice(index, 1, false); ////修改提示符出现，对号提示符消失
                value.regionId = res.data.data.regionId; ////拿到返回的区域ID

                this.$showTipsToast(1, "添加成功", true); ////提示框
              }
            })
            .catch(error => {
              console.log(error);
            });
        }
      } else {
        ////说明是操作了修改一个区域的按钮
        if (value.regionName.match(/^[ ]*$/)) {
          ////判断是否为多个空格的方法
          this.$toast("修改失败，名称不能超过为空哦~");
          return;
        } else if (value.regionName.length > 20) {
          this.$toast("修改失败，名称不能超过20个字符哦~");
          return;
        } else {
          ////点了修改一个区域的确认按钮，需要请求修改区域名称接口
          this.$request({
            method: "post",
            url: "/region/updateRegionById",
            data: {
              token: this.$store.state.token,
              regionId: value.regionId,
              regionName: value.regionName
            }
          })
            .then(res => {
              if (res.data.code != 0) {
                this.$showTipsToast(3, res.data.message);
                ////说明信息填写错误,控制失败了，
                return;
              } else {
                ////、控制成功了
                this.ifNameChange.splice(index, 1, false); ////通过这种方式修改数组值才可以实时更新到VIEW上  VUE的规定
                if (value.followState === 1) {
                  ///如果是收藏区域  修改名字后需要更新收藏区域的名字
                  this.upShouChangdataName(value); ////
                }
                // /////需要延时一下等待 input的禁用状态被更新为激活状态后 才能使用失焦事件
                this.$nextTick(() => {
                  //正确写法
                  document.getElementById(index).blur(); ////失去焦点
                });
                // 补BUG 20200327 需要判断并把修改的场景名字提交到仓库用于实时更新

                if (
                  value.regionId ===
                  this.$store.state.publicinfo.regionShowPage.id
                ) {
                  //如果要删除的区域ID等于当前显示的区域页面，则更新页面显示信息
                  let regionShowPage = {
                    ////区域信息更新
                    regionName: value.regionName,
                    regionId: value.regionId
                  };
                  console.log(regionShowPage);
                  this.$store.dispatch(
                    "asyUpdataRegionShowPage",
                    regionShowPage
                  ); ///
                }

                this.$showTipsToast(1, "修改成功", true); ////提示框
              }
            })
            .catch(error => {
              console.log(error);
            });
        }
      }
    },
    regionMansgeAddBtnHandle() {
      // 添加删除按钮被点击了
      if (this.addDeleteFlang === false) {
        let newAddData = {
          followState: 0,
          followTime: "",
          regionId: "",
          regionName: "",
          userId: ""
        };
        this.serveRegionListData.allRegion.unshift(newAddData); ///新增一个新的数据
        this.regionManageXiuGaiBtnHandle(0, newAddData); ////激活新增数据行的input输入框
        this.addDeleteFlang = true; ///添加新的一行和删除标志位
      } else {
        ///说明已经在添加新的区域了
        this.$nextTick(() => {
          //VUE的激活后聚焦的正确写法
          document.getElementById(0).focus(); ////聚焦
        });
        this.$showTipsToast(3, "请先完成当前区域的添加!", true);
      }
    },
    regionManageDeleteBtnHandle(index, value) {
      // 删除一个区域按钮被点击了
      if (value.regionId === "") {
        ///区域ID为空的话，是新增加的 不需要删除
        this.$showTipsToast(3, "该区域暂未保存，不需要删除!", true);
        return;
      }
      this.$request({
        method: "post",
        url: "/region/delRegionById",
        data: {
          token: this.$store.state.token,
          regionId: value.regionId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.addDeleteFlang = false; ///添加新的一行和删除标志位
            // this.ifNameChange.splice(index, 1, false); ////修改提示符出现，对号提示符消失
            this.$showTipsToast(1, "删除成功", true); ////提示框
            this.serveRegionListData.allRegion.splice(index, 1); ////通过这种方式修改数组值才可以实时更新到VIEW上  VUE的规定

            // 补BUG全部区域删了,收藏的没有删掉
            this.upShouChangdataNum(value); ///删除收藏的区域

            // 补BUG 20200327
            if (
              value.regionId === this.$store.state.publicinfo.regionShowPage.id
            ) {
              //如果要删除的区域ID等于当前显示的区域页面，则修改当前显示的区域页面为全部区域
              let regionShowPage = {
                ////默认的区域信息
                regionName: "全部区域",
                regionId: ""
              };
              this.$store.dispatch("asyUpdataRegionShowPage", regionShowPage); ///
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    regionManageShouChangBtnHandle(index, value) {
      ////收藏按钮被点击了
      this.$request({
        method: "post",
        url: "/region/updateRegionFollow",
        data: {
          token: this.$store.state.token,
          regionId: value.regionId,
          followState: "1"
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.addDeleteFlang = false; ///添加新的一行和删除标志位
            // this.ifNameChange.splice(index, 1, false); ////修改提示符出现，对号提示符消失
            value.followState = 1; ////更新本地数据的收藏状态
            this.serveRegionListData.followRegion.push(value); ////往收藏的区域添加元素
            this.$showTipsToast(1, "收藏成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    regionManageQuXiaoShouChangBtnHandle(index, value) {
      ////取消收藏按钮被点击了
      this.$request({
        method: "post",
        url: "/region/updateRegionFollow",
        data: {
          token: this.$store.state.token,
          regionId: value.regionId,
          followState: "0" ///取消收藏
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.addDeleteFlang = false; ///添加新的一行和删除标志位
            // this.ifNameChange.splice(index, 1, false); ////修改提示符出现，对号提示符消失
            value.followState = 0; ////更新本地数据的收藏状态
            this.upAlldataState(value); ///同步所有区域的收藏状态
            this.serveRegionListData.followRegion.splice(index, 1); ////删除收藏区域的元素
            this.$showTipsToast(1, "取消收藏成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    upShouChangdataName(value) {
      ///所有区域的数据名称修改成功后，实时同步到收藏区域的数据
      for (let i = 0; i < this.serveRegionListData.followRegion.length; i++) {
        if (
          value.regionId === this.serveRegionListData.followRegion[i].regionId
        ) {
          this.serveRegionListData.followRegion[i].regionName =
            value.regionName;
          return;
        }
      }
    },
    upAlldataState(value) {
      ///收藏区域的数据取消收藏后 实时更新所有区域的收藏状态
      for (let i = 0; i < this.serveRegionListData.allRegion.length; i++) {
        if (value.regionId === this.serveRegionListData.allRegion[i].regionId) {
          this.serveRegionListData.allRegion[i].followState = value.followState;
          return;
        }
      }
    },
    regionGoBtnHandle(value) {
      //// 区域跳转按钮
      console.log("11111111111111");
      if (this.regionManageState === "退出") return;
      this.$store.dispatch("asyUpdataRegionShowPage", value); ///异步提交用户的账号信息到仓库
      this.$router.replace("/controlpage/region");
    },
    regionManageReturnBtnHandle() {
      if (this.$route.query.returnToSelector === "1") {
        this.$router.replace({ path: "/controlpage/region", query: { regionSelector: "1" } });
        return;
      }
      if (this.$route.query.type !== "config" && this.$route.query.type !== "manage" && getServerApiLevelState(this).useModernRegion) {
        this.modernSelection = true;
        return;
      }
      if (this.$route.query.type === "config") {
        //说明是从配置页面进来的
        this.$router.go(-1);
      } else {
        this.$router.replace("/controlpage/region");
      }
    },
    upShouChangdataNum(value) {
      ///所有区域的数据名称修改成功后，实时同步到收藏区域的数据
      let followRegionlength = this.serveRegionListData.followRegion.length;
      for (let i = 0; i < followRegionlength; i++) {
        if (
          value.regionId === this.serveRegionListData.followRegion[i].regionId
        ) {
          this.serveRegionListData.followRegion.splice(i, 1); ////删除该元素
          // this.serveRegionListData.followRegion[i].regionName = value.regionName;
          return;
        }
      }
    }
  },
  mounted() {
    console.log("mounted阶段");
  },
  created(){if(!this.modernSelection)this.loadRegionManagement()},
};
</script>

<style>
/* 外包装部分 */
.region_manage_page_wraper {
  max-width: 1200px;
  height: 100%;
  margin: 0 auto; /* 屏幕居中，上下0px  左右自动居中 */
  border-radius: 5px;
  /* box-shadow: 0 0 1px var(--primary-color); */
  box-sizing: border-box;
  padding-top: 0px;
  padding-left: 20px;
  padding-right: 20px;

  /* background: url('../../../assets/img/background/background1.png');
    background-size: 100% auto;  */
  /* 火狐浏览器滚动条隐藏 */
  overflow: auto;
  overflow-y: scroll;
  scrollbar-color: transparent transparent;
  scrollbar-track-color: transparent;
  -ms-scrollbar-track-color: transparent;
}

/* Chrome 和 Safari滚动条隐藏 */
.region_manage_page_wraper::-webkit-scrollbar {
  display: none;
}
/* 背景颜色 */
.region_manage_background {
  width: 100%;
  height: 100%;
  position: relative;
  /* background: linear-gradient(rgb(161, 145, 231), blue);
    background: -webkit-linear-gradient(rgb(161, 145, 231), blue);
    background: -o-linear-gradient(rgb(161, 145, 231), blue); 
    background: -moz-linear-gradient(rgb(161, 145, 231), blue); */
}

.region_manage_page_content {
  /* ////  使内容区高一点以便滚动条的滑动 */
  margin-bottom: 500px;
}

/* 设置页面的灰色title样式 */
.config_title_hang_wraper {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #f2f2f2;
  padding: 0px 10px;

  box-sizing: border-box;

  position: relative;
}
.config_title_hang_wraper span {
  font-size: 16px;
  color: #666666;
}

/* <!-- 设置页面内容区域样式 --> */
.config_text_hang_wraper {
  height: 60px;
  width: 100%;
  line-height: 60px;
  padding: 0px 10px;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
}
/* 左侧文字样式 */
.config_left_text {
  color: #282828;
  font-size: 18px;
  /* border: 1px solid #f2f2f2; */
  background: none;
  outline: none;
  border: none;
  padding: 0px;
  /* border-radius: 0px; */
  height: 40px;
}
.region_manage_input_zindex {
  position: relative;
  z-index: -1;
}
.config_left_text:focus {
  color: #40a8fb;
  outline: none;
  border: 0px solid blue;
}
/* 右侧图片样式 */
.config_text_img {
  height: 14px;
  width: 14px;
  position: absolute;
  right: 10px;
  top: 23px;
}
.config_text_hang_wraper::after {
  content: "";
  display: inline-block;
  width: 1143px;
  height: 1px;
  background-color: #f2f2f2;
  position: absolute;
  bottom: 0px;
  right: 0px;
}
.config_text_hang_wraper:hover {
  /* box-shadow: 1px -1px 4px var(--primary-color) inset; */
  background-color: rgba(68, 180, 253, 0.05);
}

.config_notext_hang_tisp_wraper {
  height: 40px;
  line-height: 40px;
  color: #666666;
  padding: 0px 10px;
  box-sizing: border-box;
}

/* 区域管理激活时的样式 */
.click_add_delete_btn {
  position: absolute;
  right: 20px;
  display: inline-block;
  cursor: pointer;
}
.click_add_delete_btn img {
  height: 21px;
  width: 21px;
  position: absolute;
  right: 83px;
  top: 15px;
}
.click_add_delete_btn span {
  color: var(--primary-color);
  /* color: #5195CC; */
}
.region_config_xiugai_img {
  height: 21px;
  width: 21px;
  position: absolute;
  right: 50px;
  top: 21px;
}
.region_config_shouchang_img {
  height: 21px;
  width: 21px;
  position: absolute;
  right: 10px;
  top: 21px;
}
</style>
